import { MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'
export const COW_PROTOCOL_NAME = `CoW Protocol`

export const BRIDGE_DISCLAIMER_TOOLTIP_CONTENT: MessageDescriptor = msg`Bridging feature is exclusively operated by the indicated third party. Please review their terms.`
